import script from "./EvaluationResult.vue?vue&type=script&setup=true&lang=js"
export * from "./EvaluationResult.vue?vue&type=script&setup=true&lang=js"

import "./EvaluationResult.vue?vue&type=style&index=0&id=ab25d138&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab25d138"]])

export default __exports__